export default __webpack_public_path__ + "static/product-1-deskop-b9e425475703a26a02fab6917942b980.png";